import type { ReactNode } from "react";
import "./tag.css";

export type TagVariant = "blue" | "sand" | "glass";

type TagProps = {
  /** blue: every tag on a light ground · sand: reserved, used nowhere today · glass: on a photo. */
  variant: TagVariant;
  /** "p" when the tag stands alone above a heading (default), "span" inside a line of text. */
  as?: "p" | "span";
  className?: string;
  children: ReactNode;
};

/** Mono uppercase label that opens a section. */
export default function Tag({ variant, as: Element = "p", className, children }: TagProps) {
  return <Element className={`ds-tag ds-tag--${variant}${className ? ` ${className}` : ""}`}>{children}</Element>;
}
